import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import reportsMapper from '../mappers/reportsMapper';
import {
  REPORTS_CHECKED,
  DESELECT_ALL_REPORTS,
  RETRIEVE_OUTBOUND_REPORTS_SUCCESS,
  SELECT_ALL_REPORTS,
} from '../actions/types/ReportsActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
/* eslint-disable import/no-useless-path-segments */
import filterReportsIfExistInPostalOperator from '../../../target-node-report-selector/redux/filters/filterReportsIfExistInPostalOperator';

export const initialState = {
  nodes: [],
  carriers: [],
  selections: [],
  checkedReports: [],
};

export const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_OUTBOUND_REPORTS_SUCCESS:
      return {
        ...state,
        nodes: reportsMapper(action.payload),
        isLoading: false,
      };
    case REPORTS_CHECKED:
      return {
        ...state,
        checkedReports: filterReportsIfExistInPostalOperator(
          action.checkedReports,
          state.nodes,
        ),
      };
    case SELECT_ALL_REPORTS:
      return {
        ...state,
        checkedReports: action.payload.nodes.map(node => node.value),
      };
    case DESELECT_ALL_REPORTS:
      return {
        ...state,
        checkedReports: [],
      };
    case ENTERED_WIZARD:
      return initialState;
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
